export default {
  init() {

      //calendrier
      $('#mini-clndr').each(function() {

          moment.locale('fr');
          const currentMonth = moment().format('YYYY-MMMM');
          const nextMonth = moment().add(1, 'month').format('YYYY-MMMM');

          let events = [];
          for (var prop in window.__events) {

              let event = window.__events[prop];

              events.push({
                  date: event['start_date'],
                  title: event.title,
              });

          }

          console.log(events);



          $(this).clndr({
              moment: moment,
              weekOffset: 0,
              daysOfTheWeek: ['L', 'M', 'M', 'J', 'V', 'S', 'D'],
              numberOfRows: 5,
              template: $('#mini-clndr-template').html(),
              events: events,
              clickEvents: {
                  click: function (target) {
                      if (target.events.length) {
                          const date = target.events[0].date;
                          const href = window.location.href + '?date=' + date;

                          $.ajax(href)
                              .done(function(data, text, jqxhr) {
                                  const content = $(data).find('#js-events').html();
                                  $('#js-events').html(content);
                              })
                              .fail(function(jqxhr) {
                                  alert(jqxhr.responseText);
                              });
                      }
                  },
              },
              adjacentDaysChangeMonth: true,
              // forceSixRows: true,
          });
      });



      $('#prev-posts-link').on('click', 'a', function(e) {
        e.preventDefault();

        let $this = $(this);
        let href = $this.attr('href');



    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateSaison.js